import $ from 'jquery';
import 'svgxuse';

export default function utils() {
  
  $('html').removeClass('no-js');
  
  //_blank link esterni
  $('a[href^=http], a.external').on('click', function() {
    window.open(this.href);
    return false;
  });
}